import createRoute from '@widesk-ui/tools/createRoute';

const routes = [
	...createRoute.splitView(
		'/website_entertainments/:websiteEntertainmentId/editions',
		'website',
		'WebsiteEntertainmentSplitView',
		'Éditions du festival'
	),
	...createRoute.splitView(
		'/configuration/website_entertainments',
		'website',
		'WebsiteEntertainmentSplitView',
		'éditions de tous les festivals'
	)
];
export default routes;
